const MyMatchesPageReducer = (state, action) => {
  switch (action.type) {
    case 'MY_MATCHES_FETCHING':
      return {
        ...state,
        isFetching: true,
      };
    case 'MY_MATCHES_UPDATE':
      return {
        ...state,
        items: state.items.concat(action.data.items),
        nextUrl: action.data.nextUrl,
        isFetching: false,
      };
    case 'MY_MATCHES_ERROR':
      return {
        ...state,
        error: action.data,
        nextUrl: null,
        isFetching: false,
      };
    case 'MY_MATCHES_OVERWRITE':
      return action.data;
    default:
      return state;
  }
};

export {MyMatchesPageReducer};
